module.exports = __webpack_public_path__ + "img/ebook-hero-thumb3.6f1b50bc.png";